if (!customElements.get('chouette-cart-duo')) {
  customElements.define('chouette-cart-duo', class extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', event => {
        event.stopPropagation();
      });

      this.addEventListener('click', event => {
        const editButton = event.target.closest('[data-duo-edit]');

        if (editButton) {
          event.preventDefault();
          if (this.busy) return;

          const editor = this.querySelector('[data-duo-editor]');
          editor.hidden = !editor.hidden;
          editButton.setAttribute('aria-expanded', String(!editor.hidden));

          if (!editor.hidden) {
            editor.querySelector('[data-duo-variant]')?.focus();
          }
          return;
        }

        const addButton = event.target.closest('[data-duo-add]');
        if (!addButton) return;

        event.preventDefault();
        this.savePatch(addButton);
      });
    }

    get root() {
      return window.Shopify?.routes?.root || '/';
    }

    async request(path, body) {
      const response = await fetch(`${this.root}${path}`, {
        method: body ? 'POST' : 'GET',
        headers: {
          Accept: 'application/json',
          ...(body ? { 'Content-Type': 'application/json' } : {})
        },
        cache: 'no-store',
        ...(body ? { body: JSON.stringify(body) } : {})
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || 'CART_ERROR');
      }

      return result;
    }

    findAssociatedPatch(cart) {
      return cart.items.find(item =>
        String(item.product_id) === this.dataset.duoProduct &&
        item.properties?._duo_parent === this.dataset.duoParent &&
        String(item.properties?._duo_slot) === this.dataset.duoSlot
      );
    }

    async savePatch(button) {
      if (this.busy || window.chouetteDuoBusy) return;

      const select = this.querySelector('[data-duo-variant]');
      const status = this.querySelector('.chouette-duo__status');
      const variantId = Number(select?.value);

      if (!variantId) return;

      this.busy = true;
      window.chouetteDuoBusy = true;
      button.disabled = true;
      select.disabled = true;
      this.setAttribute('aria-busy', 'true');
      status.textContent = this.dataset.loading || 'Mise à jour…';

      let mutationStarted = false;

      try {
        const cart = await this.request('cart.js');
        const currentPatch = this.findAssociatedPatch(cart);

        if (currentPatch && currentPatch.variant_id === variantId) {
          window.location.reload();
          return;
        }

        /*
         * La modification est bloquée si une quantité a été changée
         * manuellement sur un patch associé : on évite de supprimer
         * plusieurs patchs en voulant en remplacer un seul.
         */
        if (currentPatch && currentPatch.quantity !== 1) {
          status.textContent =
            'Remettez la quantité de ce patch à 1 avant de modifier sa couleur.';
          return;
        }

        const properties = {
          ...(currentPatch?.properties || {}),
          _duo_parent: this.dataset.duoParent,
          _duo_slot: this.dataset.duoSlot
        };

        mutationStarted = true;

        await this.request('cart/add.js', {
          items: [{
            id: variantId,
            quantity: 1,
            properties
          }]
        });

        if (currentPatch) {
          /*
           * On relit le panier : l’ajout peut modifier les clés
           * des lignes lorsque les réductions sont recalculées.
           */
          const updatedCart = await this.request('cart.js');

          const oldPatch = updatedCart.items.find(item =>
            String(item.product_id) === this.dataset.duoProduct &&
            item.properties?._duo_parent === this.dataset.duoParent &&
            String(item.properties?._duo_slot) === this.dataset.duoSlot &&
            item.variant_id === currentPatch.variant_id
          );

          if (!oldPatch || oldPatch.quantity !== 1) {
            throw new Error('OLD_PATCH_NOT_FOUND');
          }

          await this.request('cart/change.js', {
            id: oldPatch.key,
            quantity: 0
          });
        }

        window.location.reload();
      } catch (error) {
        if (mutationStarted) {
          /*
           * En cas de coupure réseau, on ne relance pas l’ajout :
           * il a peut-être déjà abouti.
           */
          status.textContent =
            'La mise à jour n’a pas pu être confirmée. Rechargez le panier et vérifiez les patchs avant de réessayer.';
          button.disabled = true;
          select.disabled = true;
        } else {
          status.textContent =
            this.dataset.error || 'Impossible de mettre à jour le panier.';
        }
      } finally {
        this.busy = false;
        window.chouetteDuoBusy = false;
        this.removeAttribute('aria-busy');

        if (!mutationStarted) {
          button.disabled = false;
          select.disabled = false;
        }
      }
    }
  });
}
if (!window.chouetteDuoOrderInstalled) {
  window.chouetteDuoOrderInstalled = true;

  const installDuoOrder = () => {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    let scheduled = false;
    let observer;

    const reorder = () => {
      scheduled = false;

      const tbody = cartItems.querySelector('.cart-items tbody');
      if (!tbody) return;

      const rows = Array.from(tbody.children).filter(row =>
        row.matches('tr.cart-item[data-duo-line-token]')
      );

      const parents = new Map();

      rows.forEach(row => {
        if (!row.dataset.duoLinkedParent) {
          parents.set(row.dataset.duoLineToken, row);
        }
      });

      const groups = new Map();

      rows.forEach(row => {
        const parentToken = row.dataset.duoLinkedParent;
        if (!parentToken || !parents.has(parentToken)) return;

        if (!groups.has(parentToken)) {
          groups.set(parentToken, []);
        }

        groups.get(parentToken).push(row);
      });

      observer.disconnect();

      try {
        groups.forEach((patchRows, parentToken) => {
          const parentRow = parents.get(parentToken);

          patchRows.sort((a, b) =>
            Number(a.dataset.duoLinkedSlot || 0) -
            Number(b.dataset.duoLinkedSlot || 0)
          );

          /*
           * Le récapitulatif reste directement sous le t-shirt.
           * Les vraies lignes des patchs viennent ensuite.
           */
          let anchor = parentRow;

          if (
            anchor.nextElementSibling?.classList.contains('chouette-duo-row')
          ) {
            anchor = anchor.nextElementSibling;
          }

          patchRows.forEach(patchRow => {
            if (anchor.nextElementSibling !== patchRow) {
              anchor.after(patchRow);
            }

            anchor = patchRow;
          });
        });
      } finally {
        observer.observe(cartItems, {
          childList: true,
          subtree: true
        });
      }
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(reorder);
    };

    observer = new MutationObserver(schedule);

    observer.observe(cartItems, {
      childList: true,
      subtree: true
    });

    schedule();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installDuoOrder, {
      once: true
    });
  } else {
    installDuoOrder();
  }
}
